import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';

export function About() {
  const { t } = useTranslation(['about']);

  return (
    <section id="about" className="about">
      <div>
        <h2 className="about__title">{t('about:whereTitle')}</h2>
        <div>
          {profile.timeline.map((entry) => (
            <div key={entry.id} className="timeline__row">
              <span
                className={`timeline__period${entry.current ? ' timeline__period--current' : ''}`}
              >
                {/* Ranges like 2024–26 reorder without isolation under RTL. */}
                <bdi>{entry.period}</bdi>
              </span>
              <span className="timeline__role">
                <strong className="timeline__org">{entry.organisation}</strong>{' '}
                <span className="timeline__detail">· {t(`about:roles.${entry.id}`)}</span>
              </span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2 className="about__title">{t('about:beyondTitle')}</h2>
        <div className="beyond">
          {profile.beyond.map((item) => (
            <div key={item} className="beyond__card">
              <div className="beyond__label">{t(`about:beyond.${item}.title`)}</div>
              <p className="beyond__text">{t(`about:beyond.${item}.body`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
